var map = {
	"./logo-bocconi.svg": 1571,
	"./logo-caltech.svg": 1572,
	"./logo-cambridge.svg": 1573,
	"./logo-edinburgh.svg": 1574,
	"./logo-oxford.svg": 1575,
	"./logo-texas.svg": 1576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1570;